import { db } from "@/main";

export default {
    state: {
        userList: [],
        unsuscribe: null,
        activities: [
            {
                text: '01 - Agencia concesionaria Camiones',
                value: 'truck_agency'
            },
            {
                text: '02 - Agencia concesionaria Autos',
                value: 'car_agency'
            },
            {
                text: '03 - Lubricentro Camiones',
                value: 'truck_lubrication'
            },
            {
                text: '04 - Lubricentro Autos',
                value: 'car_lubrication'
            },
            {
                text: '05 - Transporte de Cargas',
                value: 'cargo_transportation'
            },
            {
                text: '06 - Transporte de Pasajeros',
                value: 'passenger_transport'
            },
            {
                text: '07 - Talleres Mecánicos Camiones',
                value: 'truck_workshop'
            },
            {
                text: '08 - Talleres Mecánicos Autos',
                value: 'car_workshop'
            },
            {
                text: '09 - Estaciones de Servicio',
                value: 'service_station'
            },
            {
                text: '10 - Otros',
                value: 'others'
            },
        ]
    },
    mutations: {
      ADD_USER(state, user) {
        state.userList.push(user)
        // TODO: ORDER LIST?
      },
      UPDATE_USER(state, user) {
        let index = state.userList.findIndex(
          obj => obj.id == user.id
        );
        state.userList.splice(index, 1, user);
      },
      DELETE_USER(state, user ) {
        let index = state.userList.findIndex(
          obj => obj.id == user.id
        );
        state.userList.splice(index, 1);
      },
      CLEAR_USERS(state) {
        state.userList = []
      }
    },
    actions: {
        getUsers( { state, commit } ) {
            if( state.userList.length > 0 ) {
                return new Promise( (resolve, reject) => { resolve() })
            }

            return new Promise((resolve, reject) => {
                
                state.unsuscribe = db.collection("users").onSnapshot(snap => {
                    snap.docChanges().forEach(change => {
                        const user = change.doc.data()
                        // Fill the user profile with extra data
                        user.id = change.doc.id
                        user.full_name = user.last_name + ', ' + user.first_name
                        user.zones = []
                        user.locations.forEach(zone => {
                        if(!user.zones.includes(zone.zone))
                            user.zones.push(zone.zone)
                        });

                        const activity = state.activities.find( e => e.value == user.activity )
                        if( activity )
                            user.activity_t = activity.text

                        if (change.type === "added") {      
                            let userTmp = state.userList.find( e => e.id === user.id )
                            if( !userTmp )                                                                
                                commit('ADD_USER', user)
                        }
                        if (change.type === "modified") {
                            commit( 'UPDATE_USER', user )
                        }
                        if (change.type === "removed") {
                            commit( 'DELETE_USER', user )
                        }
                    });
                    resolve()
                }, function(error) {
                    commit('SET_ERROR', { section: 'Users', function: 'getUsers', msg: error });
                    reject()
                });
            })
        },
        addUser( { commit }, user ) {
            return new Promise((resolve, reject) => {
                db.collection("users")
                .add(user)
                .then(function(docRef) {
                    // Do this in getUsers, that is call by FireStore when DB change
                    //user.id = docRef.id;
                    //commit( 'ADD_USER', user )
                    resolve()
                })
                .catch(function(error) {
                    commit('SET_ERROR', { section: 'Users', function: 'addUser', msg: error });
                    reject()
                })
            })
        },
        updateUser( { commit }, user ) {
            return new Promise((resolve, reject) => {
                db.collection("users")
                .doc(user.id)
                .update(user)
                .then(() => {
                    // Do this in getUsers, that is call by FireStore when DB change  
                    //commit( 'UPDATE_USER', user )
                    resolve()
                })
                .catch(function(error) {
                    commit('SET_ERROR', { section: 'Users', function: 'updateUser', msg: error });
                    reject()
                })
            })
        },
        deleteUser( { commit }, user ) {
            return new Promise((resolve, reject) => {
                db.collection("users")
                .doc(user.id)
                .delete()
                .then(function() {
                    // Do this in getUsers, that is call by FireStore when DB change
                    //commit( 'DELETE_USER', user )
                    resolve()
                })
                .catch(function(error) {
                    commit('SET_ERROR', { section: 'Users', function: 'deleteUser', msg: error });
                    reject()
                });
            })
        },
        toggleStatusUser( { commit }, user ) {
            user.is_active = !user.is_active
            return new Promise((resolve, reject) => {
                db.collection("users")
                .doc(user.id)
                .update({
                    is_active: user.is_active
                })
                .then(function() {
                    // Do this in getUsers, that is call by FireStore when DB change
                    //commit( 'UPDATE_USER', user )
                    resolve()
                })
                .catch(function(error) {
                    commit('SET_ERROR', { section: 'Users', function: 'toggleStatusUser', msg: error });
                    reject()
                });
            })
        },
        unsuscribeUser( {state} ) {
            if( state.unsuscribe ) {
                return state.unsuscribe()
            }
            return true
        }
    }
}